import React from "react";
import { HashRouter as Router, Routes, Route } from "react-router-dom";
import AboutPage from "./AboutPage";
import Portfolio from "./Portfolio";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<AboutPage />} />
        <Route path="/portfolio" element={<Portfolio />} />
      </Routes>
    </Router>
  );
}

export default App;
